import Commons from './Common';
import Global from './Global';

/**
 * @param {object} [axiosOpts] Commons.Axios 5번째 인자 — 예: { timeout: 900000 } (장시간 POST용)
 */
export const apiRequest = async (method = 'post', path, params, axiosOpts) => {
  const url = `${Global.base.useUrl}${path}`;
  const { data } = await Commons.Axios(method, url, params, null, axiosOpts || {});
  return data;
};
